import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ObservacaoMonitoriaDialog } from '../monitoria.component';
import { MonitoriaService } from '../monitoria.service';
import { BeanMonitoryFiles } from 'src/bean/BeanMonitoryFiles';
import { ToastrService } from 'ngx-toastr';
import { Observable, ReplaySubject } from 'rxjs';
import { ParecerPlanoDeAcaoService } from '../../parecer-plano-acao/parecer-plano-acao.service';
import { BeanActionPlanFiles } from 'src/bean/BeanActionPlanFiles';

@Component({
  selector: 'app-anexos-dialog',
  templateUrl: './anexos-dialog.component.html',
  styleUrls: ['./anexos-dialog.component.css']
})
export class AnexosDialogComponent implements OnInit {
  @Input()
  requiredFileType:string;
  fileName = '';
  
  public base64Output : string;
  public file:File = null;
  public beanMonitoryFiles : BeanMonitoryFiles[]=[];
  public beanActionPlanFiles : BeanActionPlanFiles[]=[];
  
  public addBeanMonitoryFiles : BeanMonitoryFiles = new BeanMonitoryFiles(null, null, null, null, null);
  public addBeanActionPlanFiles : BeanActionPlanFiles = new BeanActionPlanFiles(null, null, null, null, null);
  public sessionExpired: boolean = false;
  qtdAnexos: number  = 0;
  adicionouAnexo : boolean = false;

  constructor(
    private toastr: ToastrService,
    private monitoriaService : MonitoriaService,
    private planoAcaoService : ParecerPlanoDeAcaoService,
    public dialogRef: MatDialogRef<ObservacaoMonitoriaDialog>,
    @Inject(MAT_DIALOG_DATA) public data: {
      idMonitoria: string,
      idPlanoAcao: string,
      dsPlanoAcao: string,
      isFinalizado: Boolean
    },) { }

  ngOnInit(): void {
     
    if(this.data.idMonitoria != undefined){
      this.buscarAnexoMonitoria()
    }else if(this.data.idPlanoAcao != undefined ){
      this.buscarAnexoMonitoriaPlanoAcao()
    }
    

    
  }

  buscarAnexoMonitoria(){
    this.monitoriaService.buscarAnexo(this.data.idMonitoria)
    .then((ret) =>{
      if(ret.length > 0){
      
       this.beanMonitoryFiles = ret;
       this.qtdAnexos = this.beanMonitoryFiles.length;

      }else{
        this.beanMonitoryFiles = [];
        this.qtdAnexos = 0;
      }

    }, errorResponse =>{

      this.setSessionExpired(errorResponse);
    })
  }

  buscarAnexoMonitoriaPlanoAcao(){
    this.planoAcaoService.buscarAnexo(this.data.idPlanoAcao)
    .then((ret) =>{
      if(ret.length > 0){
      
       this.beanActionPlanFiles = ret;
       this.qtdAnexos = this.beanActionPlanFiles.length;

      }else{
        this.beanActionPlanFiles = [];
        this.qtdAnexos = 0;
      }

    }, errorResponse =>{

      this.setSessionExpired(errorResponse);
    })
  }



  


  onFileSelected(event, fileUpload) {

    //this.anexoSpinner = true;
    this.file = event.target.files[0];

    if (this.file) {

        
      if(this.data.idMonitoria != undefined){
        this.adicionarArquivoMonitoria(fileUpload);

      }else if(this.data.idPlanoAcao != undefined){
        this.adicionarArquivoPlanoAcao(fileUpload);

      }

        
        

    }
  }


  adicionarArquivoMonitoria(fileUpload){

    this.fileName = this.file.name;

    this.convertFile(this.file).subscribe(base64 => {

      this.addBeanMonitoryFiles.moanDsArquivo = base64
      this.addBeanMonitoryFiles.moniIdCdMonitoria = this.data.idMonitoria
      this.addBeanMonitoryFiles.moanDsNomeArquivo = this.file.name
      this.base64Output = base64;

      this.monitoriaService.addAnexo(this.addBeanMonitoryFiles).then((ret: any)=>{
        this.toastr.success('Arquivo gravado com sucesso!', 'Anexar Arquivo')
        this.addBeanMonitoryFiles = new BeanMonitoryFiles(null, null, null, null, null);
        fileUpload.value = ''

        this.buscarAnexoMonitoria();

        this.adicionouAnexo = true;
        
      },
      errorResponse => { //CASO ERRO
        this.setSessionExpired(errorResponse);
        //this.anexoSpinner = false;

      }).catch((retorno:any) => {
        this.toastr.error(retorno.error.error_description, 'ERRO!')
        //this.anexoSpinner = false;

      });


    }, errorResponse =>{

      this.setSessionExpired(errorResponse);
    });
  }


  onNoClick(): void {
    let data = {
      adicionouAnexo : this.adicionouAnexo
    };
    this.dialogRef.close(data);

  }

  adicionarArquivoPlanoAcao(fileUpload){

    this.fileName = this.file.name;

    this.convertFile(this.file).subscribe(base64 => {

      this.addBeanActionPlanFiles.plaaDsArquivo = base64
      this.addBeanActionPlanFiles.placIdCdPlanoacao = this.data.idPlanoAcao
      this.addBeanActionPlanFiles.plaaDsNomearquivo = this.file.name
      this.base64Output = base64;

      this.planoAcaoService.addAnexo(this.addBeanActionPlanFiles).then((ret: any)=>{
        this.toastr.success('Arquivo gravado com sucesso!', 'Anexar Arquivo')
        this.addBeanActionPlanFiles = new BeanActionPlanFiles(null, null, null, null, null);
        fileUpload.value = ''

        this.buscarAnexoMonitoriaPlanoAcao();
      },
      errorResponse => { //CASO ERRO
        this.setSessionExpired(errorResponse);
        //this.anexoSpinner = false;

      }).catch((retorno:any) => {
        this.toastr.error(retorno.error.error_description, 'ERRO!')
        //this.anexoSpinner = false;

      });


    }, errorResponse =>{

      this.setSessionExpired(errorResponse);
    });
  }

  convertFile(file : File) : Observable<string> {
    const result = new ReplaySubject<string>(1);
    const reader = new FileReader();
    reader.readAsBinaryString(file);
    reader.onload = (event) => result.next(btoa(event.target.result.toString()));
    return result;
  }

  downloadAnexo(moanIdCdMonitoriaAnexo : string){
    //this.anexoSpinner = true
    this.monitoriaService.downloadAnexo(moanIdCdMonitoriaAnexo)
    .then((ret)=>{

      const downloadLink = document.createElement('a');

      downloadLink.href = 'data:application/octet-stream;base64,' + ret.moanDsArquivo;
      downloadLink.download = ret.moanDsNomeArquivo;
      downloadLink.click();
      //this.anexoSpinner = false
    }, errorResponse =>{

      this.setSessionExpired(errorResponse);
    })

  }

  downloadAnexoPlanoAcao(plaaIdCdPlanoacaoanexo : string){
    //this.anexoSpinner = true
    this.planoAcaoService.downloadAnexo(Number(plaaIdCdPlanoacaoanexo))
    .then((ret)=>{

      const downloadLink = document.createElement('a');

      downloadLink.href = 'data:application/octet-stream;base64,' + ret.plaaDsArquivo;
      downloadLink.download = ret.plaaDsNomearquivo;
      downloadLink.click();
      //this.anexoSpinner = false
    }, errorResponse =>{

      this.setSessionExpired(errorResponse);
    })

  }


  deletarAnexo(moanIdCdMonitoriaAnexo : string){

    this.monitoriaService.deletarAnexo(moanIdCdMonitoriaAnexo)
    .subscribe((data:any)=>{
      this.toastr.success('Arquivo excluido com sucesso!')
      
      this.buscarAnexoMonitoria();

    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    })

  }

  deletarAnexoPlanoAcao(plaaIdCdPlanoacaoanexo : string){

    this.planoAcaoService.deletarAnexo(plaaIdCdPlanoacaoanexo)
    .subscribe((data:any)=>{
      this.toastr.success('Arquivo excluido com sucesso!')
      
      this.buscarAnexoMonitoriaPlanoAcao();

    }, errorResponse => {

      this.setSessionExpired(errorResponse);
    })

  }

  public setSessionExpired(errorResponse:any) {

    if(errorResponse.status == 401){

      this.sessionExpired = true;
    }

    return this.sessionExpired;
  }

  public resetSessionExpired(){

    if(this.sessionExpired){

      this.sessionExpired = false;

      setTimeout(() => this.dialogRef.close({sessionExpired:true}));
		}
  }

}
